<template>
    <div class="bee_list_base_layout">


        <div v-if="listData.length > 0" class="item_list_layout">
            <div v-for="(item, index) in listData" class="item_list">
                <div class="item_list_name_avatar" style="">
                    <img v-if="item.avatar" :src="item.avatar" class="av_logo">
                    <img v-else :src="default_avatar" class="av_logo">

                    <div class="item_list_name">{{ item.name }}</div>


                </div>


                <div class="item_list_xp" style="text-align: end;">
                    <div>+{{ fNumber(item.dividendXp) }}</div>
                    <div class="user_ic_logo"></div>

                </div>
            </div>
        </div>
        <div v-else>

            <div class="empty_list_layout">
                <div class="empty_list_div"></div>
                <div class="empty_list_txt"> No data available </div>
            </div>

        </div>


    </div>
</template>

<script>
import icon_avatar from '../../assets/icon_pc_user_avcter.png';
export default {
    name: 'UserListView',

    components: {

    },

    props: {
        listData: [],
    },

    data() {
        return {
            default_avatar: icon_avatar,
            listDataTest: [
                {
                    "userId": "bee222222@qq.com",
                    "name": "bee222222",
                    "avatar": "",
                    "dividendXp": 2527.2000000000016
                },
                {
                    "userId": "bee999991@qq.com",
                    "name": "bee999991",
                    "avatar": false,
                    "dividendXp": 2500
                }
            ]
        }
    },

    watch: {
    },

    methods: {

        doClose() {

        },
        isDecimal(num) {
            return /^\d+\.\d+$/.test(num);
        },
        fNumber(num1) {
            if (this.isDecimal(num1)) {
                let m = Math.pow(10, 2); //放大10的2次方倍  100
                let value = (num1 * m) / m;  //(0.1*100 + 0.2*100）/100
                return value.toFixed(1)
            } else {
                return num1;
            }

        },


        formatDate(timestamp) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            return `${month}/${day}/${year}`;
        }


    },

    mounted() {
    },


}

</script>

<style scoped>
.bee_list_base_layout {
    flex-direction: column;
    display: flex;
}

.bee_user_txt {
    color: #666;
    text-align: center;
    font-family: "SF Pro Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    flex: 1;
}

.bee_user_top_layout {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    display: none;
}

.empty_list_layout {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.empty_list_txt {
    color: #C3C3C3;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 28px;
}

.empty_list_div {
    width: 214px;
    height: 136px;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/empty_invite.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin-top: 40px;

}

.item_list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: -webkit-fill-available;
    width: -moz-available;
    margin-top: 24px;
}

.item_list_layout {
    display: flex;
    width: -webkit-fill-available;
    width: -moz-available;
    flex-direction: column;
}

.item_list_text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 80px;
}

.item_list_name_avatar {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #333;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    text-align: start;
    flex: 1;
    display: flex;
    flex-direction: row;
}



.av_logo {
    width: 52px;
    height: 52px;
    flex-shrink: 0;
    border-radius: 100%;
    background: #ffc04d;
}

.item_list_xp {
    color: #FFB60D;
    font-family: "PingFang SC";
    font-size: 26px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.item_list_time {
    color: #666;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    /* 171.429% */
}

.item_list_name {
    color: #000;
    font-size: 26px;
    font-style: normal;
    font-weight: 400;
    line-height: 52px;
    margin-left: 8px;
}

.user_ic_logo {
    width: 26px;
    height: 26px;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/ic_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin-left: 4px;
}


@media (max-width: 1920px) {
    .av_logo {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        border-radius: 100%;
        background: #ffc04d;
    }

    .item_list_name {
        color: #333;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin-left: 8px;
    }

    .item_list_xp {
        color: #FFB60D;
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .user_ic_logo {
        width: 14px;
        height: 14px;
        background-image: url("https://www.bee.com/wp-content/uploads/2025/03/ic_logo.png");
        background-size: cover;
        background-repeat: no-repeat;
        box-sizing: border-box;
        margin-left: 4px;
    }

    .item_list {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: -webkit-fill-available;
        width: -moz-available;
        margin-top: 8px;
    }

    .empty_list_txt {
        color: #C3C3C3;
        font-family: "PingFang SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 18px;
    }

    .empty_list_div {
        width: 107px;
        height: 68px;
        background-image: url("https://www.bee.com/wp-content/uploads/2025/03/empty_invite.png");
        background-size: cover;
        background-repeat: no-repeat;
        box-sizing: border-box;
        margin-top: 40px;
        margin-bottom: 8px;
    }
}
</style>